import { Pipe, PipeTransform } from '@angular/core';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';

@Pipe({
  name: 'newDevice',
  standalone: false,
})
export class NewDevicePipe implements PipeTransform {
  transform(deviceName: string, isNew: boolean): string {
    return isNew ? deviceName + `<i class='${ZiroIcons.STAR} ps-1'></i>` : deviceName;
  }
}
